import ReportThumb from "../../components/ReportThumb";
import { TYPO } from "styles/Typo";
import moment from "moment-timezone";
import React, { useState } from "react";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import DividerButton from "components/common/divider/button";
import DividerLine from "components/common/divider/line";
import InterestReportModal from "./ReportModal";
export const ListTemp = React.memo(
  ({
    agenda,
    animation,
    env = "default",
  }: {
    agenda: any;
    animation: string;
    env?: string;
  }) => {
    const router = useRouter();
    return (
      <div
        className={`group cursor-pointer flex gap-4 w-full justify-between flex-start items-start ${
          animation === "fadeOut"
            ? "fade-out-strategy"
            : animation === "fadeIn"
            ? "fade-in-strategy"
            : ""
        }`}
        onClick={(e) => {
          router.push(
            `/discuss/${
              agenda.url_slug ? `${agenda.url_slug}-${agenda.id}` : agenda.id
            }`
          );
        }}
        data-gtm-id={
          env === "bs" ? `watchlist-report-bs-list` : `watchlist-report-list`
        }
      >
        <div className="flex flex-col gap-2">
          <span
            className={`${TYPO.TYPO6_SB} text-gray80  w-fit line-clamp-2 group-hover:text-blue40`}
          >
            {agenda.title}
          </span>
          <span className={`${TYPO.TYPO7_RG} text-gray40  w-fit`}>
            {moment(agenda.issue_at).format("YYYY.M.D")}
          </span>
        </div>

        <ReportThumb
          data={agenda}
          width={84}
          className=" rounded-[10px] shrink-0  w-[84px]"
        />
      </div>
    );
  }
);
ListTemp.displayName = "ListTemp";
function InterestNewsRaderReport({ data }: { data: any }) {
  const [isModalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation("main");
  if (!data) return null;
  return (
    <div>
      <h3 className={`${TYPO.TYPO4_SB} text-gray80 px-6 pt-6`}>{t("reports")}</h3>
      <div className="p-6 flex flex-col gap-[40px]">
        {data?.slice(0, 3)?.map((item: any, index: number) => (
          <ListTemp key={index} agenda={item} animation={""} />
        ))}
      </div>
      {data?.length > 3 && (
        <DividerButton
          text={t("seeMore")}
          onClick={() => {
            setModalOpen(true);
          }}
          data-gtm-id={`watchlist-report-more-btn`}
        />
      )}
      {isModalOpen && (
        <InterestReportModal
          setModalOpen={setModalOpen}
          isModalOpen={isModalOpen}
          data={data}
        />
      )}
    </div>
  );
}

export default InterestNewsRaderReport;
